import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

// A plain shell. The sign-in flow lives in the auth guard (unauthenticated → /auth/login) and the
// login page itself — there is no OIDC callback to process and no cross-domain redirect that could
// loop, which is what the error panel and redirect cooldown that used to live here existed for.
@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent {}
